// extracted by mini-css-extract-plugin
module.exports = {"CTABlock":"CTABlock_CTABlock__D8_j_","heading":"CTABlock_heading__xrevX","inner":"CTABlock_inner__ooxB2","btn":"CTABlock_btn__knbPW"};